/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_TitleInputs */

const es_home_intro_title = /** @type {(inputs: Home_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nexo de tu conocimiento empresarial`)
};

const en_home_intro_title = /** @type {(inputs: Home_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The nexus of your enterprise knowledge`)
};

/**
* | output |
* | --- |
* | "The nexus of your enterprise knowledge" |
*
* @param {Home_Intro_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_title = /** @type {((inputs?: Home_Intro_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_title(inputs)
	return en_home_intro_title(inputs)
});
export { home_intro_title as "home.intro.title" }